import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompanyVoteResultSearchFilter } from '../models/companyVoteResultSearchFilter';
import { PaginatedResponse } from '../models/paginatedResponse';
import { CompanyVoteResultSearchDto } from '../models/api/companyVoteResultSearchDto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyVoteResultService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/company-vote-results`;

  /**
   * Search company vote results with pagination and filtering across all companies
   */
  search(request: CompanyVoteResultSearchFilter): Observable<PaginatedResponse<CompanyVoteResultSearchDto>> {
    return this.http.post<PaginatedResponse<CompanyVoteResultSearchDto>>(`${this.apiUrl}/search`, request);
  }

  /**
   * Export company vote results to CSV based on search criteria
   */
  exportToCsv(request: CompanyVoteResultSearchFilter): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/search/export`, request, {
      responseType: 'blob'
    });
  }

  /**
   * Delete a company vote result by ID
   */
  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
